import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Modal from '../../components/Modal';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';

const SignSuccessModal = ({ showSuccessModal }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Modal show={showSuccessModal}>
      {/* <ModalHeading heading='Congratulations' /> */}
      <InputsSection style={{ marginTop: '3rem' }}>
        <p className='primaryText' style={{ fontSize: '1.3rem' }}>
          {t('screens.signPdf.successBody')}
        </p>
      </InputsSection>
      <ModalButtons submitButtonLabel={t('screens.signPdf.loginBtn')} onSubmit={() => history.replace('/login')} />
    </Modal>
  );
};

export default SignSuccessModal;
